// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XYbiv {
    flex: 1;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: relative;
    min-height: 24px;
    height: 100%;
    width: 100%;
}

.xp5em {
    border-radius: 15px;
    min-height: 80px;
}

.I8MAs {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 5px;
}

.JUGjZ {
    border-radius: 15px;
}

.GjkpX {
    margin-top: -6px;
    font-size: 24px;
    padding-left: 5px;
    padding-right: 5px;
    color: rgba(255, 255, 255, 0.9);
    font-weight: bold;
    font-family: 'BalooBhaijaan2', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    position: relative;
    z-index: 2;
}

.CIuqW {
    font-size: 90px;
    margin-top: -6px;
}

.q0q8c {
    color: rgba(255, 255, 255, 0.9);
    margin-top: -1px;
    margin-left: 5px;
}

.Tbw27 {
    color: rgba(255, 255, 255, 0.9);
    margin-top: -3px;
    padding-top: 4px;
    padding-bottom: 4px;
}

._tONN {
    animation: HFyfl 0.25s ease-in-out;
}

@keyframes HFyfl {
    0%, 100% { transform: translateX(0); }
    20% { transform: translateX(2px); }
    40% { transform: translateX(-4px); }
    60% { transform: translateX(4px); }
    80% { transform: translateX(-2px); }
}

.xfeqC {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: relative;
    z-index: 2;
}

.VN7kR {
    flex: 1;
    gap: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.Hu1QE {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 53%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
}

.IEdfL {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 53.5%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
}

.luYJK {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: opacity 0.15s ease;
}

.pzZZB {
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.3), transparent);
}

.AKGnn {
    width: 100%;
    height: 100%;
    background: linear-gradient(to left, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.3), transparent);
}

._O9EG {
    color: rgba(255, 255, 255, 0.9);
}

.ffJ2C {
    margin-left: -30px;
}

.ZOhE8 {
    margin-right: -30px;
}

.F05fb {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    pointer-events: none;
}

@media (min-width: 768px) {
    .GjkpX {
        font-size: 28px;
        margin-top: 2px;
    }

    .CIuqW {
        margin-top: 5px;
        font-size: 100px;
    }

    .q0q8c {
        width: 22px;
        height: 22px;
    }

    .Tbw27 {
        width: 70px;
        height: 70px;
        margin-top: -4px;
        margin-left: 5px;
    }

    .ffJ2C {
        margin-left: -50px;
    }

    .ZOhE8 {
        margin-right: -50px;
    }

    ._O9EG {
        width: 80px;
        height: 80px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/commander/CommanderCard.css"],"names":[],"mappings":"AAAA;IACI,OAAO;IACP,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,+BAA+B;IAC/B,iBAAiB;IACjB,gGAAgG;IAChG,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,WAAW,wBAAwB,EAAE;IACrC,MAAM,0BAA0B,EAAE;IAClC,MAAM,2BAA2B,EAAE;IACnC,MAAM,0BAA0B,EAAE;IAClC,MAAM,2BAA2B,EAAE;AACvC;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,OAAO;IACP,MAAM;IACN,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0FAA0F;AAC9F;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yFAAyF;AAC7F;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":[".card {\n    flex: 1;\n    border-radius: 5px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n    position: relative;\n    min-height: 24px;\n    height: 100%;\n    width: 100%;\n}\n\n.cardBig {\n    border-radius: 15px;\n    min-height: 80px;\n}\n\n.gradientBackground {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-radius: 5px;\n}\n\n.gradientBig {\n    border-radius: 15px;\n}\n\n.text {\n    margin-top: -6px;\n    font-size: 24px;\n    padding-left: 5px;\n    padding-right: 5px;\n    color: rgba(255, 255, 255, 0.9);\n    font-weight: bold;\n    font-family: 'BalooBhaijaan2', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n    position: relative;\n    z-index: 2;\n}\n\n.textBig {\n    font-size: 90px;\n    margin-top: -6px;\n}\n\n.skullIcon {\n    color: rgba(255, 255, 255, 0.9);\n    margin-top: -1px;\n    margin-left: 5px;\n}\n\n.skullIconBig {\n    color: rgba(255, 255, 255, 0.9);\n    margin-top: -3px;\n    padding-top: 4px;\n    padding-bottom: 4px;\n}\n\n.shaking {\n    animation: shake 0.25s ease-in-out;\n}\n\n@keyframes shake {\n    0%, 100% { transform: translateX(0); }\n    20% { transform: translateX(2px); }\n    40% { transform: translateX(-4px); }\n    60% { transform: translateX(4px); }\n    80% { transform: translateX(-2px); }\n}\n\n.deathCountContainer {\n    flex: 1;\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    position: relative;\n    z-index: 2;\n}\n\n.deathCountContainerBig {\n    flex: 1;\n    gap: 0;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n}\n\n.leftSide {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 53%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2;\n}\n\n.rightSide {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    width: 53.5%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2;\n}\n\n.sideOverlay {\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    transition: opacity 0.15s ease;\n}\n\n.leftGradient {\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(to right, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.3), transparent);\n}\n\n.rightGradient {\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(to left, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.3), transparent);\n}\n\n.sideIcon {\n    color: rgba(255, 255, 255, 0.9);\n}\n\n.sideIconLeft {\n    margin-left: -30px;\n}\n\n.sideIconRight {\n    margin-right: -30px;\n}\n\n.centerContainer {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1;\n    pointer-events: none;\n}\n\n@media (min-width: 768px) {\n    .text {\n        font-size: 28px;\n        margin-top: 2px;\n    }\n\n    .textBig {\n        margin-top: 5px;\n        font-size: 100px;\n    }\n\n    .skullIcon {\n        width: 22px;\n        height: 22px;\n    }\n\n    .skullIconBig {\n        width: 70px;\n        height: 70px;\n        margin-top: -4px;\n        margin-left: 5px;\n    }\n\n    .sideIconLeft {\n        margin-left: -50px;\n    }\n\n    .sideIconRight {\n        margin-right: -50px;\n    }\n\n    .sideIcon {\n        width: 80px;\n        height: 80px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `XYbiv`,
	"cardBig": `xp5em`,
	"gradientBackground": `I8MAs`,
	"gradientBig": `JUGjZ`,
	"text": `GjkpX`,
	"textBig": `CIuqW`,
	"skullIcon": `q0q8c`,
	"skullIconBig": `Tbw27`,
	"shaking": `_tONN`,
	"shake": `HFyfl`,
	"deathCountContainer": `xfeqC`,
	"deathCountContainerBig": `VN7kR`,
	"leftSide": `Hu1QE`,
	"rightSide": `IEdfL`,
	"sideOverlay": `luYJK`,
	"leftGradient": `pzZZB`,
	"rightGradient": `AKGnn`,
	"sideIcon": `_O9EG`,
	"sideIconLeft": `ffJ2C`,
	"sideIconRight": `ZOhE8`,
	"centerContainer": `F05fb`
};
export default ___CSS_LOADER_EXPORT___;
